module.exports = __webpack_public_path__ + "static/media/logo-header-nologo.621c3aab.png";